import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {
  i18n
} from './plugins/i18n'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')

import './assets/scss/style.scss';